import { fakeApiHelper } from '~~utils/CommonUtils';
import ApiService from '~~commonAPIs/ApiService';

const debugStatus = {
  updatePermission: false,
};

const FirstBase = {
  updatePermission: ({ userUniqid, teamUniqid, authority }) => {
    if (debugStatus.updatePermission) {
      return fakeApiHelper(200, 'success', {
        data: {
          permission: 'ADMIN',
        },
        error: false,
        message: 'Request successfully',
      });
    }

    return ApiService.put(`/api/users/${userUniqid}/permission/firstbase/${teamUniqid}`, { data: { authority } });
  },
};

export default FirstBase;
